'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { isEmpty, trim } from 'lodash';
import Button from '@/components/shared/Button';
import { FormStatus } from '@/components/ui/FormStatus';
import { onlyNumbers } from '@/utils/onlyNumbers';

type SuccessContainerProps = {
  cnpj?: string;
  email?: string;
};

export const SuccessContainer = ({ cnpj, email }: SuccessContainerProps) => {
  const router = useRouter();
  const [needRedirectToVayon, setNeedRedirectToVayon] = useState(!isEmpty(cnpj) && !isEmpty(email));

  useEffect(() => {
    if (needRedirectToVayon) {
      setTimeout(() => {
        setNeedRedirectToVayon(false);
        router.push(
          `${process.env.NEXT_PUBLIC_VAYON_URL}/#!/cadastro-externo/${onlyNumbers(cnpj)}/${trim(email)}`
        );
      }, 3000);
    }
  }, [router, needRedirectToVayon, cnpj, email]);

  return (
    <FormStatus
      status="success"
      title={
        <h2>
          {needRedirectToVayon ? 'Aguarde!' : 'Pronto!'}
          <br />
          <br className="hidden lg:block" />
          {needRedirectToVayon
            ? 'Estamos te redirecionando para seguir com seu cadastro na AXA.'
            : 'Você foi redirecionado para seguir com seu cadastro na AXA.'}
        </h2>
      }
      content={
        <div className="flex flex-col gap-2 pt-4 lg:flex-row lg:gap-4 lg:pt-6">
          <Button className="w-fit" asChild>
            <Link href="/para-corretores" prefetch={false}>
              Ir para corretores
            </Link>
          </Button>
          <Button outline className="w-fit" asChild>
            <Link href="/" prefetch={false}>
              Ir para Home
            </Link>
          </Button>
        </div>
      }
    />
  );
};
